import { useAuthContext } from '../hooks';

export function useHasDistributorSite() {
  const { user } = useAuthContext();
  const { distributorSite, distributorOrg } = user || {};
  const hasDistributorSite = !!user?.distributorSite;
  return { hasDistributorSite, distributorSite, distributorOrg };
}
